import React, { useState } from 'react'
import { Text, Container, Flex, Button, useBreakpointValue } from '@chakra-ui/react';
import { BellIcon } from '@heroicons/react/24/outline';
import { HiMenu } from 'react-icons/hi';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';
import { HeaderTitle } from '@utils/HeaderContent';
import { useFrillWidget } from '@utils/hooks/useFrillWidget';
import { MobileDrawer } from './Navigation/MobileDrawer';
import { usePaymentStatus } from '@utils/hooks/queries';

const Header: React.FC = () => {

  const isMobile = useBreakpointValue({ base: true, xl: false });
  const { user } = useAuth();
  const frillWidget = useFrillWidget();

  const location = useLocation();
  const currentPath = location.pathname;
  const isDashboard = currentPath == '/dashboard';

  const [open, setOpen] = useState(false)
  const { paymentFailed } = usePaymentStatus();

  const headerText = HeaderTitle(currentPath, user?.name || '');

  return (
    <>
      {isMobile &&
        <Container px={isMobile ? 4 : 8} py={3} css={{ "@media print": { display: "none" } }} position={"fixed"} top={paymentFailed ? "70px" : 0} zIndex={3} background={"gray.50"}>
          <Flex gap={4} align="center" justifyContent={isDashboard ? "space-around" : "flex-start"} >
            <Flex gap={4} align={'center'}>
              <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
                <HiMenu />
              </Button>
            </Flex>

            <Text fontWeight={'bold'}> { headerText } </Text>

            {isDashboard &&
              <Flex gap={2} align="center">
                <Button variant='subtle' colorPalette="gray" className='notif' px={"unset"} onClick={() => {
                  frillWidget?.open();
                }}>
                  <BellIcon fontSize={"sm"} />
                </Button>
              </Flex>
            }
          </Flex>
        </Container>
      }

      <MobileDrawer open={open} onOpenChange={(e) => setOpen(e.open)} />
    </>
  );
};

export default Header;
